<template>
  <div>
    <ul v-if="tipoFormulario === 'salvar'" class="nav nav-tabs pl-0 mb-5">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: abaAtiva === 'form' }" type="button" @click="abaAtiva = 'form'">
          Formulário
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" :class="{ active: abaAtiva === 'importacao' }" type="button"
          @click="abaAtiva = 'importacao'">
          Importação
        </button>
      </li>
    </ul>

    <div v-show="abaAtiva === 'form'" class="mt-4">
      <form @submit.prevent="submit">
        <div class="mdn-Row">
          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'nome'" v-model="formulario.nome"
              :placeholder="'Nome'" data-vv-as="Nome" v-validate="'required|max:255'"
              :error="validationErrors.first('nome')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="number" :name="'disponibilidade_sla'" v-model="formulario.disponibilidade_sla"
              :placeholder="'Disponibilidade SLA'" data-vv-as="Disponibilidade SLA" v-validate="'required'"
              :error="validationErrors.first('disponibilidade_sla')" />
          </div>
        </div>

        <div class="mdn-Row mt-4">
          <div class="mdn-Col-xs mdn-u-marginTop--xs">
            <div class="container-botoes">
              <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
                type="submit">
                {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
              </button>
              <button
                class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
                type="button" @click="fecharModal">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div v-show="abaAtiva === 'importacao'">
      <div class="upload-dropzone">
        <input ref="fileInput" type="file" accept=".csv,.xlsx" class="d-none" @change="onFileChange" />

        <div v-if="!arquivoImportacao" @click="$refs.fileInput.click()">
          <strong>Clique para enviar</strong>
          <br />
          <small>CSV ou XLSX • arquivos grandes suportados</small>
        </div>

        <div v-else>
          <p><strong>{{ arquivoImportacao.name }}</strong></p>

          <div class="progress mt-2">
            <div class="progress-bar" :style="{ width: uploadProgress + '%' }">
              {{ uploadProgress }}%
            </div>
          </div>

          <p v-if="preparandoArquivo" class="mt-2 text-muted">
            Preparando arquivo…
          </p>

          <p v-if="prontoParaEnviar" class="mt-2 text-success">
            Arquivo pronto para importação
          </p>

          <div class="mt-3 d-flex gap-2 justify-content-center">
            <button class="btn btn-primary" :disabled="!prontoParaEnviar" @click="submitImportacao">
              Importar
            </button>

            <button class="btn btn-link text-danger" :disabled="uploading" @click="resetUpload">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.upload-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  background: #fafafa;
}
</style>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'FormularioCtrlDisponibilidadeComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    disponibilidade: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      abaAtiva: 'form',
      arquivoImportacao: null,
      uploadProgress: 0,
      uploading: false,
      preparandoArquivo: false,
      prontoParaEnviar: false,
      formulario: {
        id: this.disponibilidade.id || '',
        nome: this.disponibilidade.nome || '',
        disponibilidade_sla: this.disponibilidade.disponibilidade_sla || '',
      }
    }
  },

  methods: {
    ...mapActions('ctrlDisponibilidade', [
      'salvarDisponibilidade',
      'atualizarDisponibilidade',
      'importarDisponibilidades'
    ]),

    onFileChange(event) {
      this.arquivoImportacao = event.target.files[0]
      this.barraProgresso()
    },

    barraProgresso() {
      this.uploadProgress = 0
      this.preparandoArquivo = true
      this.prontoParaEnviar = false

      const interval = setInterval(() => {
        this.uploadProgress += Math.floor(Math.random() * 10) + 5

        if (this.uploadProgress >= 100) {
          this.uploadProgress = 100
          this.preparandoArquivo = false
          this.prontoParaEnviar = true
          clearInterval(interval)
        }
      }, 200)
    },

    resetUpload() {
      this.arquivoImportacao = null
      this.uploadProgress = 0
      this.uploading = false
      this.preparandoArquivo = false
      this.prontoParaEnviar = false

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    async submitImportacao() {
      if (!this.arquivoImportacao || this.uploading) return

      const formData = new FormData()
      formData.append('arquivo', this.arquivoImportacao)

      this.uploading = true

      try {
        await this.importarDisponibilidades({
          formData,
          onUploadProgress: (e) => {
            if (!e.total) return
            this.uploadProgress = Math.round((e.loaded * 100) / e.total)
          }
        })

        this.$emit('disponibilidadeSalva')
        this.fecharModal()
      } catch (err) {
        console.error('Erro no upload', err)
      } finally {
        this.uploading = false
      }
    },

    async submit() {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      try {
        const payload = {
          ...this.formulario
        }

        if (this.tipoFormulario === 'salvar') {
          await this.salvarDisponibilidade(payload)
        } else {
          await this.atualizarDisponibilidade(payload)
        }

        this.limparCampos()
        this.$emit('disponibilidadeSalva')
        this.fecharModal()
      } catch (error) {
        console.error('Erro ao salvar disponibilidade:', error)
      }
    },

    limparCampos() {
      this.formulario = {
        id: '',
        nome: '',
        disponibilidade_sla: '',
      }
      this.$validator.reset()
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>

